import React from 'react';

import EntryPage from '../Components/EntryPage/EntryPage';


const EntryPageIndex = () => {
    return (
        <div className="App">
            <EntryPage />
        </div>
    )
}

export default EntryPageIndex;